import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Footer.css';

interface FooterProps {}

const Footer: React.FC<FooterProps> = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  
  // 处理导航点击，跳转后滚动到顶部
  const handleNavigate = (path: string) => {
    navigate(path);
    window.scrollTo(0, 0);
  };
  
  // 按类别组织导航链接，类似苹果官网的结构
  const footerSections = [
    {
      title: t('footer.company'),
      links: [
        { label: t('nav.about'), href: '/about' },
        { label: t('nav.news'), href: '/news' },
        { label: t('nav.contact'), href: '/contact' }
      ]
    },
    {
      title: t('footer.business'),
      links: [
        { label: t('nav.services'), href: '/services' },
        { label: t('nav.solutions'), href: '/solutions' }
      ]
    }
  ];

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* 主要内容区域 */}
        <div className="footer-main">
          {/* Logo 和简介 */}
          <div className="footer-brand">
            <button onClick={() => handleNavigate('/')} className="footer-logo">
              <span className="footer-logo-text">KOSEMET</span>
            </button>
            <p className="footer-description">
              {t('footer.description')}
            </p>
          </div>

          {/* 导航分组 */}
          <div className="footer-sections">
            {footerSections.map((section, index) => (
              <div key={index} className="footer-section">
                <h3 className="footer-section-title">{section.title}</h3>
                <ul className="footer-section-links">
                  {section.links.map((link, linkIndex) => (
                    <li key={linkIndex} className="footer-section-item">
                      <button 
                        onClick={() => handleNavigate(link.href)} 
                        className="footer-section-link"
                      >
                        {link.label}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* 分隔线 */}
        <div className="footer-divider"></div>

        {/* 底部信息 */}
        <div className="footer-bottom">
          <div className="footer-legal">
            <p className="copyright-text">
              {t('footer.copyrightFull')}
            </p>
            <div className="legal-links">
              <a 
                href="https://beian.miit.gov.cn" 
                target="_blank" 
                rel="noopener noreferrer"
                className="legal-link"
              >
                粤ICP备2025487498号
              </a>
            </div>
          </div>
          
          {/* 可选：社交媒体链接或其他信息 */}
          <div className="footer-extra">
            <p className="police-record">
              粤公网安备44180202000822号
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
